/* eslint-disable @typescript-eslint/no-explicit-any */
export default function List(props: { children: any }) {
  return <div className='ml-3 sm:ml-6'>{props.children}</div>
}
